export default "__VITE_ASSET__m6HpPDXq__"